import type { ComponentType } from "react";
import { BorderCanadianDocumentForm } from "~/modules/orders/order-documents/border-canada/form";
import { BorderCanadianOrderDocumentSettingsForm } from "~/modules/orders/order-documents/border-canada/settings-form";
import { BorderUsDocumentForm } from "~/modules/orders/order-documents/border-us/form";
import { BorderUsOrderDocumentSettingsForm } from "~/modules/orders/order-documents/border-us/settings-form";
import { PickupInstructionsDocumentForm } from "~/modules/orders/order-documents/pickup-instructions/form";
import { PickupInstructionsOrderDocumentSettingsForm } from "~/modules/orders/order-documents/pickup-instructions/settings-form";
import {
  OPT_IN_ORDER_DOCUMENT_ORDER_STATUSES,
  ORDER_DOCUMENT_SLUG,
  ORDER_DOCUMENT_SLUGS,
  type OrderDocumentSlug,
  orderDocumentMetadataBySlug,
  requiredOrgBaseCurrencyForOrderDocumentSlug,
} from "~/shared/documents/order-document-settings";
import type { OptInOrderDocumentDefinition, OrderDocumentFormProps } from "./types";

type OrderDocumentComponents = {
  FormComponent: ComponentType<OrderDocumentFormProps>;
  SettingsFormComponent: ComponentType;
};

const ORDER_DOCUMENT_COMPONENTS: Record<OrderDocumentSlug, OrderDocumentComponents> = {
  [ORDER_DOCUMENT_SLUG.borderUs]: {
    FormComponent: BorderUsDocumentForm,
    SettingsFormComponent: BorderUsOrderDocumentSettingsForm,
  },
  [ORDER_DOCUMENT_SLUG.borderCanada]: {
    FormComponent: BorderCanadianDocumentForm,
    SettingsFormComponent: BorderCanadianOrderDocumentSettingsForm,
  },
  [ORDER_DOCUMENT_SLUG.pickupInstructions]: {
    FormComponent: PickupInstructionsDocumentForm,
    SettingsFormComponent: PickupInstructionsOrderDocumentSettingsForm,
  },
};

/**
 * Canonical registry of opt-in order document slugs.
 * @see docs/OPT_IN_ORDER_DOCUMENTS.md
 */
const orderDocumentDefinition = (slug: OrderDocumentSlug): OptInOrderDocumentDefinition => {
  const metadata = orderDocumentMetadataBySlug[slug];
  return {
    id: slug,
    requiredOrgBaseCurrencyCode: requiredOrgBaseCurrencyForOrderDocumentSlug(slug),
    orderStatuses: OPT_IN_ORDER_DOCUMENT_ORDER_STATUSES,
    menuItem: { label: metadata.menuLabel },
    settingsNav: metadata.settingsNav,
    ...ORDER_DOCUMENT_COMPONENTS[slug],
  };
};

export const OPT_IN_ORDER_DOCUMENT_DEFINITIONS: readonly OptInOrderDocumentDefinition[] = ORDER_DOCUMENT_SLUGS.map(orderDocumentDefinition);
